<template>
    <div
        id="conferma-ordine"
        class="bg-light"
    >
        <div class="body-wrapper">
            <gallery-header />
            <main>
                <div class="container-fluid mt-5">
                    <div class="row align-items-center">
                        <div class="col-md-6 col-lg-8">
                            <h2 class="titolo-pagina text-uppercase mb-0 text-center text-md-left">
                                {{ $t("Ordine confermato") }}
                            </h2>
                        </div>
                        <div class="col-md-6 col-lg-4 mt-4 mt-md-0">
                            <ul class="d-flex justify-content-center justify-content-md-end mb-0">
                                <li>
                                    <a
                                        href="javascript:void(0)"
                                        class="pulsante-stampa btn btn-primary btn-rikorda1"
                                        role="button"
                                        onclick="window.print();"
                                    >
                                        {{ $t("Stampa ricevuta") }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div
                        class="dati-ordine mt-5"
                        v-show="loaded"
                    >
                        <p class="consegna-scelta text-blurikorda mb-0">
                            {{ $t("Modalità di consegna selezionata") }}:&nbsp;
                            <strong class="tipo-consegna">{{
                                delivery === 'F' ? $t("Presso punto vendita") : $t("A domicilio") }}</strong>
                        </p>
                        <address class="mb-0 mt-1">
                            <strong class="text-blurikorda">
                                {{ deliveryInfo.name }}
                            </strong>
                            <br>{{ deliveryInfo.address }}
                            <br>{{ deliveryInfo.zip + " " + deliveryInfo.city + " (" + deliveryInfo.province + ")"}}
                        </address>

                        <table class="prodotti-acquistati tabella-responsive table table-striped mt-3 w-100">
                            <thead>
                                <tr>
                                    <th
                                        scope="col"
                                        class="px-1"
                                    >{{ $t("# ordine") }}</th>
                                    <th
                                        scope="col"
                                        class="px-1"
                                    >{{ $t("Prodotto") }}</th>
                                    <th
                                        scope="col"
                                        class="px-1"
                                    >{{ $t("Quantità") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="detail in orderDetails"
                                    :key="detail.trackingId"
                                >
                                    <td
                                        data-title="# ordine"
                                        class="px-1 align-middle"
                                    >{{ detail.trackingId }}</td>
                                    <td
                                        data-title="Prodotto"
                                        class="px-1 align-middle"
                                    >{{ detail.articleDescription}}</td>
                                    <td
                                        data-title="Quantità"
                                        class="px-1 align-middle"
                                    >{{ detail.quantity}}</td>
                                </tr>
                                <tr class="totale text-blurikorda font-titoli-rikorda">
                                    <td
                                        colspan="2"
                                        class="px-1 align-middle text-right d-none d-md-table-cell"
                                    >
                                        {{ $t("Totale") }}
                                    </td>
                                    <td
                                        data-title="Totale"
                                        class="px-1 align-middle"
                                    >{{ total | toCurrency }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <p
                            class="mb-0 mt-3 text-center"
                            v-if="this.delivery === 'D'"
                        >
                            {{$t("Per richiedere la fattura contatta il fotografo.")}}
                        </p>

                        <p class="mb-0 mt-3 text-center">
                            {{ $t("Potrai verificare lo stato di avanzamento nella sezione") }}
                            &nbsp;
                            <a
                                href="javascript:void(0)"
                                @click="goToOrders"
                            >
                                {{ $t("I miei ordini") }}
                            </a>
                            .
                        </p>
                        <p class="mb-0 mt-1 text-center">
                            {{ $t("Riceverai un'e-mail con la conferma della spedizione e il numero di tracking.") }}
                        </p>

                        <div class="text-center mt-3">
                            <a
                                href="javascript:void(0)"
                                class="pulsante-home btn btn-primary btn-rikorda1"
                                @click="goToEvent"
                            >
                                {{ $t("Torna all'evento") }}
                            </a>
                        </div>
                    </div>

                </div>

            </main>

            <gallery-footer :showRikorda="true" />
        </div>
    </div>
</template>
<script>
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";

export default {
    name: "GalleryOrderConfirm",

    components: {
        GalleryHeader,
        GalleryFooter
    },

    data() {
        return {
            galleryUrl: "",
            orderId: "",
            delivery: "",
            deliveryInfo: {},
            orderDetails: [],
            total: 0,
            loaded: false
        };
    },

    computed: {},

    mounted() {
        this.galleryUrl = this.$route.params.galleryUrl;
        this.orderId = this.$route.params.orderId;
        this.loadOrder();
    },

    methods: {
        loadOrder() {
            this.$api.getOrderInfo(this.orderId).then((response) => {
                console.debug("GET_ORDER_INFO", response);
                if (response.orderInfo) {
                    var orderInfo = response.orderInfo;
                    this.delivery = orderInfo.consegna;
                    switch (this.delivery) {
                        case "F":
                            this.deliveryInfo.name =
                                orderInfo.datiFotografo.Ragionesociale;
                            this.deliveryInfo.address =
                                orderInfo.datiFotografo.Indirizzo;
                            this.deliveryInfo.zip = orderInfo.datiFotografo.Cap;
                            this.deliveryInfo.city =
                                orderInfo.datiFotografo.Citta;
                            this.deliveryInfo.province =
                                orderInfo.datiFotografo.Provincia;
                            break;
                        case "D":
                            this.deliveryInfo = orderInfo.shippingData;
                            break;
                    }
                    this.orderDetails = orderInfo.orderCheckoutInfoDetails;
                    this.total = parseFloat(orderInfo.total);

                    this.loaded = true;
                }
            });
        },

        goToOrders() {
            this.$router.push({ name: "gallery-account-orders" });
        },

        goToEvent() {
            this.$router.push({
                name: "gallery-dashboard",
                params: { galleryUrl: this.galleryUrl }
            });
        }
    }
};
</script>
<style scoped>
</style>
